document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // Cart drawer
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('.cart-overlay');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
  }
  cartOpenBtns.forEach(function (btn) { btn.addEventListener('click', openCart); });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeCart); });

  // Product gallery thumbnail swap
  var mainImage = document.getElementById('MainProductImage');
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (mainImage && full) {
        mainImage.src = full;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });

  // Add to cart via AJAX so the drawer opens instead of navigating away
  var addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          form.submit();
        });
    });
  });
});
